import ReactSelect from "react-select";

/**
 * NILAI TERPILIH: `value` ATAU `defaultValue`
 *
 * Isi prop ini selalu diteruskan ke `value` milik ReactSelect, jadi select-nya
 * terkendali sepenuhnya oleh induk - namanya saja yang historis `defaultValue`.
 *
 * `value` diterima sebagai alias karena penamaan itu menjebak: menulis
 * `value={...}` terasa paling wajar, tapi dulu prop itu tidak dikenal sehingga
 * ReactSelect menerima `value={undefined}` dan diam-diam berubah menjadi
 * uncontrolled - pilihan tersimpan di state internalnya sendiri lalu hilang
 * begitu komponennya mount ulang, misalnya saat berpindah tab. Tidak ada error
 * apa pun, hanya select yang tiba-tiba kosong.
 *
 * Bila keduanya diisi, `value` yang menang.
 */
export default function FilterReactSelect({ value, defaultValue, placeholder, options, isLoading, setValue, menuPosition = "fixed" }) {
  const nilaiTerpilih = value !== undefined ? value : defaultValue;

  return (
    <div className="">
      <ReactSelect
        value={nilaiTerpilih}
        options={options}
        placeholder={placeholder}
        isLoading={isLoading}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
        })}
        menuPosition={menuPosition}
        onChange={setValue}
        styles={{
          singleValue: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
          menu: (styles) => ({ ...styles, zIndex: 999 }),
          control: (styles) => ({ ...styles, border: 0, borderBottom: "1px solid #E1E8E6", borderBottomWidth: 2, boxShadow: "none" }),
          option: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
          placeholder: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
          multiValue: (styles) => ({ ...styles, backgroundColor: "#C7D2CF", borderRadius: 5 }),
          dropdownIndicator: (styles) => ({ ...styles, color: "#00000" }),
          indicatorSeparator: (styles) => ({ ...styles, alignSelf: "stretch", marginBottom: 8, marginTop: 8, width: 2, backgroundColor: "#ffff" }),
        }}
      />
    </div>
  );
}
